module.exports = __webpack_public_path__ + "img/greyList1.323a9475.png";